export const categories = [
  {
    slug: "mingxing-heiliao",
    name: "明星黑料",
    description: "明星艺人不可告人的秘密与黑历史大起底",
    icon: "ri-spy-line",
  },
  {
    slug: "lianqing-baoguang",
    name: "恋情曝光",
    description: "明星地下恋情、出轨劈腿实锤全记录",
    icon: "ri-heart-pulse-line",
  },
  {
    slug: "chouwen-jiemi",
    name: "丑闻揭秘",
    description: "娱乐圈重大丑闻深度调查与独家揭秘",
    icon: "ri-alert-line",
  },
  {
    slug: "zongyi-neimu",
    name: "综艺内幕",
    description: "热门综艺节目幕后黑幕与不为人知的潜规则",
    icon: "ri-tv-line",
  },
  {
    slug: "pianchang-baoliao",
    name: "片场爆料",
    description: "剧组片场一线爆料，明星真实人品大曝光",
    icon: "ri-camera-line",
  },
  {
    slug: "siren-shenghuo",
    name: "私生活",
    description: "明星私下真实生活状态，豪宅、炫富、混乱私交",
    icon: "ri-home-smile-line",
  },
];